export default __webpack_public_path__ + "static/media/logo-ufficio-turistico.ce63af81.png";